module.exports = __webpack_public_path__ + "img/gray-calendar-linear-20x20.fa5e3a3f.svg";